module.exports = __webpack_public_path__ + "img/cazoo-grid.0cbf7100.jpg";